export default __webpack_public_path__ + "static/media/success.cc80e411.png";